'use client';

import type { ProductTourPresentation } from '../lib/types';

type ProductTourSpotlightProps = {
  presentation: ProductTourPresentation;
  waitsForAction: boolean;
  onDismissBackdrop?: () => void;
  backdropColor?: string;
};

export function ProductTourSpotlight({
  presentation,
  waitsForAction,
  onDismissBackdrop,
  backdropColor = 'rgba(10, 6, 2, 0.55)',
}: ProductTourSpotlightProps) {
  if (presentation !== 'center') {
    return null;
  }

  return (
    <div
      onClick={waitsForAction ? undefined : onDismissBackdrop}
      style={{
        position: 'absolute',
        inset: 0,
        background: backdropColor,
        pointerEvents: waitsForAction ? 'none' : 'auto',
      }}
    />
  );
}
